export default __webpack_public_path__ + "src/images/contract.svg";